const redundantFields = ['Nazwa', 'Ostatnie zajęcia', 'Zajęcia grupowe'];

export default redundantFields;
